import { BorderButton } from "../buttons/BorderButton";

interface Props {
  visible: boolean;
  onSave: () => void;
  onCancel: () => void;
  disabled?: boolean;
}

export function UnsavedChanges(props: Props) {
  if (!props.visible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 z-20 flex w-full items-center bg-white px-4 py-4 shadow sm:block">
      <strong className="sm:mb-2 sm:block sm:text-center">
        You have unsaved changes.
      </strong>
      <div className="sm:text-center">
        <BorderButton
          type="submit"
          onClick={props.onSave}
          className="ml-4 mr-4 px-8"
          disabled={
            typeof props.disabled !== "undefined" ? props.disabled : false
          }
        >
          Save
        </BorderButton>
        <BorderButton onClick={props.onCancel} className="px-8">
          Discard changes
        </BorderButton>
      </div>
    </div>
  );
}
